import script from "./ProductsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsInfo.vue?vue&type=style&index=0&id=42cd0dc4&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cd0dc4"]])

export default __exports__